var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"mt-4"},_vm._l((_vm.publications),function(publication,i){return _c('Publication',{key:i,attrs:{"publication":publication}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }